(function () {
  function initFaq(root) {
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.parentElement.classList.toggle('open');
      });
    });
  }

  function initSticky() {
    var hero = document.querySelector('.sa-lp .hero');
    var sticky = document.getElementById('saStickyCta');
    if (!hero || !sticky) return;

    window.addEventListener(
      'scroll',
      function () {
        var past = window.scrollY > hero.offsetHeight;
        sticky.classList.toggle('show', past);
        document.body.classList.toggle('sa-pad-bottom', past);
      },
      { passive: true }
    );
  }

  function initUpgrade() {
    var checkbox = document.getElementById('saMemberUpgrade');
    var buyBtn = document.getElementById('saBuyBtn');
    var buySmall = document.getElementById('saBuySmall');
    var priceBig = document.getElementById('saPriceBig');
    var priceNote = document.getElementById('saPriceNote');
    var courseCheckout = document.getElementById('sa-course-checkout');
    var membershipCheckout = document.getElementById('sa-membership-checkout');

    if (!checkbox) return;

    var priceCourse = checkbox.getAttribute('data-price-course') || '$59';
    var noteCourse = checkbox.getAttribute('data-note-course') || 'One payment. Lifetime access.';
    var priceMembership = checkbox.getAttribute('data-price-membership') || '$0';
    var noteMembership = checkbox.getAttribute('data-note-membership') || 'due today, then $39/mo after your 7-day trial';

    function apply() {
      var on = checkbox.checked;

      if (courseCheckout) courseCheckout.hidden = on;
      if (membershipCheckout) membershipCheckout.hidden = !on;

      if (priceBig) priceBig.textContent = on ? priceMembership : priceCourse;
      if (priceNote) priceNote.textContent = on ? noteMembership : noteCourse;

      if (buyBtn && !on) {
        var labelNode = buyBtn.querySelector('.sa-buy-label');
        if (labelNode) labelNode.textContent = buyBtn.getAttribute('data-label-course') || 'Enroll Now';
        if (buySmall) buySmall.textContent = buyBtn.getAttribute('data-small-course') || '';
      }
    }

    checkbox.addEventListener('change', apply);
    apply();
  }

  function initBilling() {
    var monthly = { price: '$39 <small>/month</small>', note: 'Billed monthly. Cancel anytime.', foot: 'Free for 7 days, then $39/month. Cancel anytime.' };
    var annual = { price: '$399 <small>/year</small>', note: '2 months free. Cancel anytime.', foot: 'Free for 7 days, then $399/year. Cancel anytime.' };

    document.querySelectorAll('.sa-lp .toggle').forEach(function (toggle) {
      toggle.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggle.querySelectorAll('button').forEach(function (b) {
            b.classList.remove('on');
          });
          btn.classList.add('on');
          var card = toggle.closest('.offer-card');
          if (!card) return;
          var data = btn.getAttribute('data-billing') === 'annual' ? annual : monthly;
          var priceEl = card.querySelector('[data-m-price]');
          var noteEl = card.querySelector('[data-m-note]');
          var footEl = card.querySelector('[data-m-foot]');
          if (priceEl) priceEl.innerHTML = data.price;
          if (noteEl) noteEl.textContent = data.note;
          if (footEl) footEl.textContent = data.foot;
        });
      });
    });
  }

  function initVideoPoster() {
    document.querySelectorAll('.sa-lp .vimeo-wrap.has-poster').forEach(function (wrap) {
      var poster = wrap.querySelector('.vimeo-poster');
      var src = wrap.getAttribute('data-video-src');
      var title = wrap.getAttribute('data-video-title') || 'Video';
      if (!poster || !src) return;

      poster.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = title;
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
        wrap.classList.remove('has-poster');
      });
    });
  }

  function boot() {
    if (window.__saLpBooted) return;
    window.__saLpBooted = true;
    if (!document.querySelector('.sa-lp')) return;
    // FAQ lives in its own .sa-lp section — query the whole document
    initFaq(document);
    initSticky();
    initUpgrade();
    initBilling();
    initVideoPoster();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
